const paymentValuePolicies = {
    ALLOW_ANY_PAYMENT_VALUE: 'ALLOW_ANY_PAYMENT_VALUE',
    ALLOW_ONLY_BETWEEN_MINIMUM_INCLUSIVE_AND_MAXIMUM_INCLUSIVE_PAYMENT_VALUE: 'ALLOW_ONLY_BETWEEN_MINIMUM_INCLUSIVE_AND_MAXIMUM_INCLUSIVE_PAYMENT_VALUE',
    DISALLOW_ANY_CHANGES_ON_PAYMENT_VALUE : 'DISALLOW_ANY_CHANGES_ON_PAYMENT_VALUE',
    ALLOW_ONLY_MINIMUM_OR_PAYMENT_VALUE: 'ALLOW_ONLY_MINIMUM_OR_PAYMENT_VALUE'
  }

export default paymentValuePolicies;